import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDefectStatus, PmsDefectStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDefectStatus>
    useData={usePmsDefectStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
